<template>
  <div class="attendee-payments-section">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'paymentControl'" key="create-loading" class="w-100" />
      <el-row v-else key="content-loading" class="w-100">
        <template v-if="paymentInfos.length > 0">
          <div class="payments-item" v-for="payment in paymentInfos" :key="payment.id + '-paymentInfo-item'">
            <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeePayments.paymentId") }}</span>
            <span @click="openPayment(payment)" class="cursor-pointer">
              <strong>#{{ payment.paymentID }}</strong>
            </span>
            <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeePayments.paymentMethod") }}</span>
            <span>
              <b>{{ getEnumsDisplay("PaymentType", payment.paymentType) }}</b>
            </span>
            <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeePayments.amount") }}</span>
            <span>
               <b>{{ $currency.format(payment.paidPrice, { code: $parseCurrency(payment.currency) }) }} </b>
            </span>
            <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeePayments.registrationDate") }}</span>
            <span>
              <b>{{ $moment(payment.createDate).format("DD MMMM YYYY, dddd HH:mm") }}</b>
            </span>
            <span>{{ $t("participantManagament.registrationSearch.detailsParticipant.attendeePayments.paymentStatus") }}</span>
            <el-dropdown placement="bottom-start">
              <span class="status payment-awaiting" :class="{ 'payment-awaiting': payment.paymentStatus == 0, rejected: payment.paymentStatus == 2, confirmed: payment.paymentStatus == 1 }">
                <i class="fas fa-clock"></i>
                <template v-if="payment.paymentStatus == 0 && payment.paymentType != 3">
                  {{ $t("summaryComponent.waiting-for-approval") }}
                </template>
                <template v-if="payment.paymentStatus == 0 && payment.paymentType == 3">
                  {{ $t("summaryComponent.payment-pending") }}
                </template>
                <template v-if="payment.paymentStatus == 1">
                  {{ $t("summaryComponent.approved") }}
                </template>
                <template v-if="payment.paymentStatus == 2">
                  {{ $t("summaryComponent.denied") }}
                </template>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="status-pending-approve" v-if="payment.paymentStatus != 1" @click.native="changePaymentStatus(payment.paymentID, 1)">
                  <i class="fas fa-check"></i>
                  {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeePayments.confirm") }}
                </el-dropdown-item>
                <el-dropdown-item class="status-pending-reject" v-if="payment.paymentStatus != 2" @click.native="changePaymentStatus(payment.paymentID, 2)">
                  <i class="fas fa-times"></i>
                  {{ $t("participantManagament.registrationSearch.detailsParticipant.attendeePayments.reject") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="attendee-payments-edit">
              <el-tooltip class="item" effect="dark" :content="$t('participantManagament.registrationSearch.detailsParticipant.attendeePayments.seeDetails')" placement="top-start">
                <el-button size="small" icon="fas fa-search" @click="openPayment(payment)" circle></el-button>
              </el-tooltip>
            </div>
          </div>
        </template>
        <el-alert type="info" v-else show-icon="el-icon-info" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeePayments.noRegistration')" :closable="false"></el-alert>
      </el-row>
    </transition>

    <!-- 
    <div class="payments-item">
      <span>Ödeme ID</span>
      <span><strong>#V8JJ167L2Z</strong></span>
      <span>Metot</span>
      <span><b>Online Ödeme</b> - Garanti POS (1022)</span>
      <span>Tutar</span>
      <span><b>9.000,00</b> TRY</span>
      <span>Kayıt tarihi</span>
      <span><b>11 May 2022, 17:07</b></span>
      <span>Ödeme durumu</span>
      <el-dropdown placement="bottom-start">
        <span class="status rejected"><i class="fas fa-times-circle"></i>Reddedildi</span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item class="status-pending-approve"><i class="fas fa-check"></i> Onayla</el-dropdown-item>
          <el-dropdown-item class="status-pending-reject"><i class="fas fa-times"></i> Reddet</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="attendee-payments-edit">
        <el-tooltip class="item" effect="dark" content="Ödeme detaylarını görüntüle" placement="top-start">
          <el-button size="small" icon="fas fa-search" circle></el-button>
        </el-tooltip>
      </div>
    </div>

    <div class="payments-item">
      <span>Ödeme ID</span>
      <span><strong>#V8JJ167L2Z</strong></span>
      <span>Metot</span>
      <span><b>Online Ödeme</b> - Garanti POS (1022)</span>
      <span>Tutar</span>
      <span><b>9.000,00</b> TRY</span>
      <span>Kayıt tarihi</span>
      <span><b>11 May 2022, 17:07</b></span>
      <span>Ödeme durumu</span>
      <el-dropdown placement="bottom-start">
        <span class="status confirmed"><i class="fas fa-check-circle"></i>Onaylandı</span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item class="status-pending-approve"><i class="fas fa-check"></i> Onayla</el-dropdown-item>
          <el-dropdown-item class="status-pending-reject"><i class="fas fa-times"></i> Reddet</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="attendee-payments-edit">
        <el-tooltip class="item" effect="dark" content="Ödeme detaylarını görüntüle" placement="top-start">
          <el-button size="small" icon="fas fa-search" circle></el-button>
        </el-tooltip>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    paymentInfos: Array,
    participant: Object
  },
  data() {
    return {
      loading: false,
      timeout: null
    };
  },
  async created() {
    this.loading = "paymentControl";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.loading = false;
    }, 500);
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    }
  },
  methods: {
    openPayment(payment) {
      this.openPaymentDetail(payment, this.participant);
    },
    async changePaymentStatus(id, status) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var payload = {
          paymentID: id,
          status: status,
          cancellationReason: null
        };
        if (status != 2) {
          var res = await this.$store.dispatch("changeParticipantStatus", payload);
          if (!res.data.alert.hasError) {
            this.$emit("refresh");
          }
        } else {
          if (this.$i18n.locale == "tr") {
            var reason = await this.$prompt("Lütfen bir sebep belirtin.", "Uyarı", {
              confirmButtonText: "Tamam",
              cancelButtonText: "Vazgeç",
              inputPattern: /(.|\s)*\S(.|\s)*/,
              inputErrorMessage: "Lütfen boş bırakmayınız."
            })
              .then(async ({ value }) => {
                payload.cancellationReason = value;
                var res = await this.$store.dispatch("changeParticipantStatus", payload);
                if (!res.data.alert.hasError) {
                  this.$emit("refresh");
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "İşlem iptal edildi."
                });
              });
          } else {
            var reason = await this.$prompt("Please provide a reason.", "Warning", {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              inputPattern: /(.|\s)*\S(.|\s)*/,
              inputErrorMessage: "Please fill in all fields."
            })
              .then(async ({ value }) => {
                payload.cancellationReason = value;
                var res = await this.$store.dispatch("changeParticipantStatus", payload);
                if (!res.data.alert.hasError) {
                  this.$emit("refresh");
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "The process has been cancelled."
                });
              });
          }
        }
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/participants/ParticipantDetails/AttendeePayments.vue